import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static classes = ["copied"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.textContent).then(() => {
      // Atualiza o texto do botão
      const originalText = this.buttonTarget.innerHTML
      this.buttonTarget.innerHTML = "Copiado!"
      this.buttonTarget.classList.add(this.copiedClass)

      // Reverte após 2 segundos
      setTimeout(() => {
        this.buttonTarget.innerHTML = originalText
        this.buttonTarget.classList.remove(this.copiedClass)
      }, 2000)
    })
  }
}